
import { useCallback } from "react";

interface UseConversationCallbacksProps {
  refreshConversation: () => void;
}

interface UseConversationCallbacksReturn {
  handleMessageSent: () => void;
}

/**
 * Custom hook to manage conversation-related callbacks
 */
export function useConversationCallbacks({
  refreshConversation
}: UseConversationCallbacksProps): UseConversationCallbacksReturn {
  
  // Callback for when a message is sent to refresh conversation
  const handleMessageSent = useCallback(() => {
    refreshConversation();
  }, [refreshConversation]);

  return {
    handleMessageSent
  };
}
